export const SITE_URL = 'https://ameliadownie.com.au';
export const SITE_NAME = 'Amelia Downie - Land Healing Practitioner';
export const DEFAULT_DESCRIPTION =
  'A unique holistic practice blending landscape design, energetic property healing and Ren Xue Qigong. 25 years of experience in creating beautiful gardens QLD, VIC and internationally. Brisbane based and operating remotely.';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/social-banner.png`;
